$(() => {
  if (I18n.locale === 'fr') {
    $.fn.datepicker.dates.en.months = ['Januar', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    $.fn.datepicker.dates.en.monthsShort = ['Janv', 'Févr', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
  } else {
    $.fn.datepicker.dates.en.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    $.fn.datepicker.dates.en.monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  }

  $('.start-date').datepicker({
    clearBtn: true,
    format: 'dd/mm/yyyy',
    todayHighlight: true,
    disableTouchKeyboard: true,
    autoclose: true,
  }).on('changeDate', (selected) => {
    const startDate = new Date(selected.date.valueOf());
    $('.end-date').datepicker('setStartDate', startDate);
  }).on('clearDate', () => {
    $('.end-date').datepicker('setStartDate', null);
  });

  $('.end-date').datepicker({
    clearBtn: true,
    format: 'dd/mm/yyyy',
    todayHighlight: true,
    disableTouchKeyboard: true,
    autoclose: true,
  }).on('changeDate', (selected) => {
    const endDate = new Date(selected.date.valueOf());
    $('.start-date').datepicker('setEndDate', endDate);
  }).on('clearDate', () => {
    $('.start-date').datepicker('setEndDate', null);
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/datapicker_config.js